import styled from 'styled-components';

import { Placeholder } from '@sorare/core/src/components/rivals/PlayLineupBox/Placeholder';
import { range } from '@sorare/core/src/lib/arrays';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { PlayLineup } from 'components/rivals/PlayLineupBox/PlayLineup';

const StyledPlaceholder = styled(Placeholder)`
  @media ${tabletAndAbove} {
    background-color: rgba(var(--c-rgb-neutral-1000), 0.11);
    backdrop-filter: blur(10px);
  }
`;

export const EmptyLineup = () => {
  return (
    <PlayLineup>
      {range(5).map(i => (
        <StyledPlaceholder key={i} />
      ))}
    </PlayLineup>
  );
};
